import React from 'react';
import { Stack } from '@mui/material';
import PlatformGlyph from '../quick-links/platform-icon';
import { QuickLinkIcon } from '../quick-links/quick-link-types';
import { quickLinkGoPath } from '../premium-profile/profile-path';

export type PublicQuickLink = {
  id: string;
  platformId: string;
  label: string;
  name: string;
  icon: QuickLinkIcon;
};

type QuickLinkListProps = {
  links: PublicQuickLink[];
  channelName: string;
  circles?: boolean;
};

function QuickLinkList({
  links,
  channelName,
  circles,
}: QuickLinkListProps): JSX.Element {
  if (circles) {
    return (
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap justifyContent="center">
        {links.map((link) => (
          <a
            key={link.id}
            href={quickLinkGoPath(channelName, link.id)}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: 64,
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <span
              style={{
                width: 52,
                height: 52,
                boxSizing: 'border-box',
                borderRadius: '50%',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(255,255,255,0.35)',
              }}
            >
              <PlatformGlyph platformId={link.platformId} name={link.name} icon={link.icon} size={52} />
            </span>
            <span>{link.platformId === 'custom' ? link.label : link.name}</span>
          </a>
        ))}
      </Stack>
    );
  }
  return (
    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {links.map((link) => (
        <li key={link.id}>
          <a
            href={quickLinkGoPath(channelName, link.id)}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
          >
            <PlatformGlyph platformId={link.platformId} name={link.name} icon={link.icon} />
            <span>{link.platformId === 'custom' ? link.label : link.name}</span>
          </a>
        </li>
      ))}
    </ul>
  );
}

QuickLinkList.defaultProps = {
  circles: false,
};

export default QuickLinkList;
